import React from 'react';
import { Typography } from 'antd';
import type { BaseFieldProps } from '../../../../types/form-renderer';
import type { VisualSearchField as VisualSearchFieldType } from '../../../../types/templates';
import { SelectionSlot } from './shared/selection-slot';
import { SearchGrid } from './shared/search-grid';

const { Text } = Typography;

type Props = BaseFieldProps<VisualSearchFieldType>;

export const VisualSearchField: React.FC<Props> = ({ field, value, onChange, commonStyle, labelStyle, error }) => {
  const slot1 = value?.slot1 ?? null;
  const slot2 = value?.slot2 ?? null;
  const slotLabels = field.slotLabels;

  const options = React.useMemo(() => (Array.isArray(field.options) ? field.options : []), [field.options]);

  const handleCardClick = (optValue: string) => {
    if (slot1 === optValue) onChange({ slot1: '', slot2: slot2 ?? '' });
    else if (slot2 === optValue) onChange({ slot1: slot1 ?? '', slot2: '' });
    else if (!slot1) onChange({ slot1: optValue, slot2: slot2 ?? '' });
    else if (!slot2) onChange({ slot1, slot2: optValue });
    else onChange({ slot1: optValue, slot2 });
  };

  const clearSlot = (slot: 1 | 2) => {
    if (slot === 1) onChange({ slot1: '', slot2: slot2 ?? '' });
    else onChange({ slot1: slot1 ?? '', slot2: '' });
  };

  const getOptionByValue = (val: string | null) => (val ? options.find(o => String(o.value) === val) : undefined);

  const getSlotForValue = (val: string): 1 | 2 | null => {
    if (val === slot1) return 1;
    if (val === slot2) return 2;
    return null;
  };

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, minWidth: 0, width: '100%' }}>
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          <SelectionSlot slot={1} label={slotLabels[0]} option={getOptionByValue(slot1)} onClear={() => clearSlot(1)} />
        </div>
        <Text type='secondary' style={{ fontSize: 11, fontWeight: 500, flexShrink: 0 }}>
          vs
        </Text>
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          <SelectionSlot slot={2} label={slotLabels[1]} option={getOptionByValue(slot2)} onClear={() => clearSlot(2)} />
        </div>
      </div>

      <SearchGrid
        options={options}
        placeholder={field.placeholder}
        getSlotForValue={getSlotForValue}
        showPip
        onCardClick={handleCardClick}
      />

      {error && (
        <Text type='danger' style={{ fontSize: 12, marginTop: 6, display: 'block' }}>
          {error}
        </Text>
      )}
    </div>
  );
};
